/* --- START: src/components/CompletionScreen.js --- */
import React, { useEffect } from 'react';
import './CompletionScreen.css';

function CompletionScreen({ onComplete }) {
  useEffect(() => {
    // Wait for the checkmark animation to finish (approx 1.5s)
    // then trigger the callback to move to the next item
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 1500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="completion-container">
      <div className="completion-content">
        <svg className="completion-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
          <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
    </div>
  );
}

export default CompletionScreen;
/* --- END: src/components/CompletionScreen.js --- */